
<div id="holiday-list">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node (click)="treeViewClick(node)" (click)="activeNode = node" [ngClass]="{ 'selected': activeNode === node }" *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="25">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-icon-button disabled></button>
            <span  class="indicator cal-3"></span>
            <span class="tree-name">{{node.poblacion}}</span>
            <button (click)="deletePoblacion(node)" class="right-icon del" mat-icon-button><mat-icon class="mat-icon">delete_forever</mat-icon></button>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node (click)="treeViewClick(node)" *matTreeNodeDef="let node;when: hasChild" (click)="activeNode = node" [ngClass]="{ 'selected': activeNode === node }" matTreeNodePadding matTreeNodePaddingIndent="30px">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <span [ngClass]="{'indicator red-class-tebex': node.level=='0', 'indicator cal-2': node.level!='0'}" ></span>
            <span class="tree-name">{{node.comunidad}}</span>
            <button *ngIf="node.level!='0'" class="right-icon add" mat-icon-button (click)="openServiceAddEdit(node)"><mat-icon class="mat-icon">add</mat-icon></button>
        </mat-tree-node>
    </mat-tree>
</div>